/*
 * @providesModule BankWithdrawalConfirmationModal
 *
 */

import {DialogV3} from 'DialogV3';
import React from 'react';
import {Text} from 'react-native';
import {WITHDRAWAL_CONFIRMATION_MODAL_DEFAULTS} from '../BankWithdrawalConstants';
import {stylesFn} from './BankWithdrawalConfirmationModal.styles';
import I18n from 'INTL';
import {ModalButton} from './ModalButton';
import SkillzImage from 'SkillzImage';
import ClientPropertyConstants from 'ClientPropertyConstants';

type BankWithdrawalConfirmationModalProps = {
  withdrawalAmount: number;
  bonusBalance: number;
  onConfirm?: () => void;
  onDismiss?: () => void;
  isRTPEnabled?: boolean;
};

export function BankWithdrawalConfirmationModal({
  withdrawalAmount,
  bonusBalance,
  onConfirm,
  onDismiss,
  isRTPEnabled,
}: BankWithdrawalConfirmationModalProps) {
  const styles = stylesFn();

  const withdrawalFeeEnabled = ClientPropertyConstants.getPlayerWithdrawalAeropayRTPFeeEnabled();

  let processingFeeText = '';

  // Apply fee only if amount is under $10
  const isUnderMinimum = withdrawalAmount < 10;

  // Exception: RTP is enabled and fee is disabled
  const shouldSkipFee = isRTPEnabled && !withdrawalFeeEnabled;

  if (isUnderMinimum && !shouldSkipFee) {
    processingFeeText = I18n.message('(fee $1.50 for withdrawals under $10)');
  }

  const bonusCashForfeitText = bonusBalance
    ? I18n.message(
        'Your Bonus Cash balance of ${0} will be forfeited if you proceed with this withdrawal.',
        bonusBalance.toFixed(2)
      )
    : '';
  return (
    <DialogV3
      showCloseButton
      onClose={onDismiss}
      headerImageComponent={
        isRTPEnabled ? (
          <SkillzImage
            source={'icon_withdrawal_option_instant_banking.png'}
            style={{width: 50, height: 60}}
          />
        ) : undefined
      }
    >
      <Text style={styles.title} allowFontScaling={false}>
        {WITHDRAWAL_CONFIRMATION_MODAL_DEFAULTS.title}
      </Text>
      <Text style={styles.subTitle} allowFontScaling={false}>
        {I18n.message(isRTPEnabled ? 'Instant Withdraw ' : 'Withdraw ')}
        <Text style={styles.textCash} allowFontScaling={false}>
          {'$' + withdrawalAmount.toFixed(2)}
        </Text>
        {I18n.message('?')}
      </Text>
      {!!processingFeeText && (
        <Text style={styles.bodyText} allowFontScaling={false}>
          {processingFeeText}
        </Text>
      )}
      {!!bonusCashForfeitText && (
        <Text style={styles.bodyText} allowFontScaling={false}>
          {bonusCashForfeitText}
        </Text>
      )}

      <ModalButton
        text={WITHDRAWAL_CONFIRMATION_MODAL_DEFAULTS.buttonTextPrimary}
        buttonContainerStyle={styles.withdrawalButtonContainer}
        onPress={onConfirm}
        buttonTextProps={{allowFontScaling: false}}
      />

      <ModalButton
        text={WITHDRAWAL_CONFIRMATION_MODAL_DEFAULTS.buttonTextSecondary}
        variant='secondary'
        buttonContainerStyle={styles.cancelButtonContainer}
        onPress={onDismiss}
        buttonTextProps={{allowFontScaling: false}}
      />
    </DialogV3>
  );
}
